import { homeMakeNewPlanCard } from '../ab/plan-card';
import { FPagePlansBlock } from '../mdl/f-page-block';
import { $el } from '../ui/elements';
import { $location } from '../y/location';
import { blkRegister } from './registry';

blkRegister<FPagePlansBlock>('plans', (_b, _s, _p, _id) => {
    return [
        $el.DIV('blk-plans w-block b b-content', window.tl_plans.map(p => homeMakeNewPlanCard('c-light', 'ui-tint-blue', p, window.tl_signup_promo, () => {
            $location.navigate(['signup'], { origin: 'pricebox-' + p.id, plan: p.id });
        })))
    ];
});
